// extracted by mini-css-extract-plugin
export default {"wrapper":"x0-z","play":"y0-z"};